<!--
  * @Author: changyunxia
  * @Date:2020年10月10日 09:48:56
  * @LastEditors: changyunxia
  * @LastEditTime: @Date:2020年10月10日 09:48:56
  * @Description: file content
  * @FilePath:@/components/HelloWorld.vue
-->
<template>
  <div class="">
    <!--日期选择 -->
    <div v-if="meetingType=='day'" class="meeting-select-bg">
      <!-- <span>日期选择</span>
      <van-field
        readonly
        clickable
        right-icon="arrow-down"
        name="datetimePicker"
        :value="valueMouth"
        @click="showPickerMouth = true"
      />
      <van-popup v-model="showPickerMouth" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          :formatter="formatter"
          @confirm="onConfirmMouth"
          @cancel="showPickerMouth = false"
        />
      </van-popup> -->
      <van-sticky :offset-top="46">
        <vue-hash-calendar
          ref="picker"
          model="inline"
          :visible.sync="isShowCalendar"
          picker-type="date"
          :is-show-week-view="showWeek"
          @click="hashClick"
          @confirm="confirmFunc"
        >
          <div slot="day" slot-scope="scope">
            <div v-if="scope.extendAttr.isToday">今</div>
            <div v-else>{{ scope.date.day }}</div>
          </div>
          <div slot="today">
            <div @click="todayFunc()">今天</div>
          </div>
          <!-- 下拉箭头 -->
          <!-- <div slot="arrow">
            <div id="oricl1">
              <div class="icon">
                <van-icon name="arrow-down" />

              </div>
            </div>
          </div> -->
        </vue-hash-calendar>
      </van-sticky>

    </div>
    <!-- 会议室选择 -->

    <div v-else-if="meetingType=='meeting'" class="meeting-select-bg meeting-flex">
      <span style="line-height: 32px;">选择会议室</span>
      <PickerForm style="width:100%" :picker-type="'meeting'" :right-icon="'arrow-down'" :default-value="'会议室1'" @PickerForm="PickerFormFunc" />

    </div>
    <!-- 会议室选择 -->
    <!-- <div v-if="meetingType=='day'" class="meeting-select-bg">
      <span>会议说明</span>
      <ul class="duration">
        每个颜色代表一个会议
      </ul>
    </div> -->
  </div>
</template>

<script>
import PickerForm from '@/components/formComm/pickerForm'
export default {
  name: 'MeetingCalendar',
  components: { PickerForm },
  props: {
    meetingType: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      meetingValue: '会议室1',
      showPicker: false,
      //   选择月
      valueMouth: this.$moment(Date.now()).format('YYYY-MM-DD'),
      showPickerMouth: false,
      currentDate: new Date(),

      // 日期控件
      isShowCalendar: true, // 是否显示弹窗
      isShowTips: false, // 是否显示下载提示
      showWeek: true,
      defaultDatetime: new Date()
    }
  },
  computed: {},
  watch: { showWeek() {} },
  created() {
  },
  mounted() {
    console.log(this.showWeek)
  },
  methods: {
    confirmFunc(val) {
      console.log(val)
    },
    // 点击今天按钮
    todayFunc() {
      this.$emit('onConfirmMouth', this.$moment(Date.now()).format('YYYY-MM-DD'))
    },
    // 点击日历  给父组件传值
    hashClick(date) {
      // console.log(date)
      // this.selectTime = this.$moment(date).format('YYYY-MM-DD')
      // this.valueMouth = this.$moment(time).format('YYYY-MM-DD')
      this.showWeek = false
      // console.log(this.showWeek)
      this.$emit('onConfirmMouth', this.$moment(date).format('YYYY-MM-DD'))
    },
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`
      } else if (type === 'month') {
        return `${val}月`
      } else if (type === 'day') {
        return `${val}日`
      }
      return val
    },
    // 选择月  赋值
    onConfirmMouth(time) {
      this.valueMouth = this.$moment(time).format('YYYY-MM-DD')
      this.showPickerMouth = false
      this.$emit('onConfirmMouth', this.valueMouth)
    },
    // 选择会议室  赋值
    PickerFormFunc(value) {
      this.$parent.getMeetingDataFunc(value)
      this.meetingValue = value.text
    }
  }
}
</script>
<style lang='scss' scoped>
/deep/.calendar_inline{
     -webkit-box-shadow: 0 2px 10px rgba(125, 126, 128, 0.16);
    box-shadow: 0 2px 10px rgba(125, 126, 128, 0.16);
}
#oricl1{
  margin-top: -13px;
  border-top: 16px solid #fff;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  height: 0;
  width: 60px;
  margin: 0 auto;
  position: relative;
}
.icon{
      position: absolute;
    right: 13px;
    top: -15px;
}
/deep/.calendar_title_date{
  padding: 1vw 2vw;
  background: none;
}
/deep/.calendar_title_date_active{
      color: #4c4c4c;
    font-weight: 100;
    font-size: 14px;
}
/deep/.calendar_confirm{
  font-size: 14px;
}
.van-cell{
    background: none;
}
.van-field__right-icon{
color:#6c6f76
}
.meeting-select-bg{
    background: #ffffff;
    margin-bottom: 10px;
    width: 100%;
        box-shadow: 0 2px 10px rgba(125,126,128,.16);
    span{
        font-size: 14px;
        color: #c3c3c3;
        // padding-left: 15px;
        text-indent: 15px;
        padding-top: 5px;
        display: block;
        width: 100%;
    }
}
.meeting-flex{
    display: flex;
}
.duration{
  display: flex;
  flex-wrap: wrap;
  margin-left: 15px;
  margin-top: 3px;
  font-size: 13px;
  color: #757575;
  line-height: 34px;
  li{
    width: 50%;
    display: flex;
    height: 15px;
    line-height: 15px;
    margin-bottom: 5px;
    i{
      display:block;
      width: 10px;
      height:10px;
      background: darkblue;
      margin-top: 2px;
    }

    div{
      font-size: 12px;
      color: #4e4e4e;
      margin-left:5px;
    }
    &:nth-child(1) i{
        background: #77e46c;
      }
      &:nth-child(2) i{
        background: #7daaff;
      }
      &:nth-child(3) i{
        background: #ffc77b;
      }
      &:nth-child(4) i{
        background: #ff7d7d;
      }
  }
}
</style>
